var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 114,
    height: 114
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_0_2408_9482_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2408_9482)",
    "data-figma-bg-blur-radius": 8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#610ECD",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "url(#paint0_linear_2408_9482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 16.5,
    width: 65,
    height: 65,
    rx: 13.3,
    stroke: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1829 35.3666H61.8167C63.6176 35.3667 65.1117 35.7494 66.2298 36.5219C67.337 37.287 68.123 38.4668 68.4593 40.1635L68.4632 40.1791C68.6027 40.7837 68.6663 41.4446 68.6663 42.1996V50.7836C68.6663 53.2546 67.963 54.9374 66.8099 56.0082C65.6499 57.0854 63.9566 57.6166 61.8333 57.6166H47.1829C46.4618 57.6166 45.7829 57.5528 45.1595 57.4125L45.1448 57.4086L45.1292 57.4067L44.848 57.353C44.5701 57.2918 44.2989 57.2086 44.0403 57.1147H44.0413C42.8845 56.6828 41.9734 55.9751 41.346 54.9584C40.7152 53.9363 40.35 52.567 40.3499 50.7836V42.1996C40.35 39.7287 41.0533 38.0459 42.2064 36.975C43.2939 35.9652 44.8504 35.4347 46.7903 35.3725L47.1829 35.3666ZM54.5003 41.6C51.7908 41.6 49.5999 43.791 49.5999 46.5004C49.6002 49.2097 51.791 51.3998 54.5003 51.3998C57.2094 51.3996 59.3995 49.2096 59.3997 46.5004C59.3997 43.7911 57.2096 41.6002 54.5003 41.6ZM44.9661 42.2504C44.0069 42.2507 43.2161 43.0411 43.2161 44.0004V49.0004C43.2164 49.9595 44.007 50.7502 44.9661 50.7504C45.9254 50.7504 46.7159 49.9597 46.7161 49.0004V44.0004C46.7161 43.041 45.9256 42.2504 44.9661 42.2504ZM64.0169 42.2504C63.0574 42.2504 62.2669 43.041 62.2669 44.0004V49.0004C62.2672 49.9597 63.0576 50.7504 64.0169 50.7504C64.9761 50.7502 65.7667 49.9596 65.7669 49.0004V44.0004C65.7669 43.0411 64.9762 42.2506 64.0169 42.2504Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1667 47.2V55.7833C74.1667 60.9167 71.2334 63.1333 66.8167 63.1333H52.1834C50.9334 63.1333 49.8167 62.95 48.85 62.5833C48.0667 62.3 47.3834 61.8833 46.8334 61.35C46.5334 61.0667 46.7667 60.6167 47.1834 60.6167H61.8167C67.9834 60.6167 71.65 56.95 71.65 50.8V42.2C71.65 41.8 72.1 41.55 72.3834 41.85C73.5167 43.05 74.1667 44.8 74.1667 47.2Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2408_9482",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.37398 0 0 0 0 0.193943 0 0 0 0 0.607543 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2408_9482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2408_9482",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2408_9482_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2408_9482",
    x1: 25,
    y1: 17,
    x2: 89,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#DB6704",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB6704",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBox);
export default __webpack_public_path__ + "static/media/money-box.6d245c845e9272506544a4bca1f6562b.svg";
export { ForwardRef as ReactComponent };